import React from "react";

import Form from "@Components/Form";
import { URLS, DISTRICT_URL, STATE_FETCH_URL } from "configs/constants";

const initialValues = {
  state: "",
  name: "",
};

const DistrictForm = () => {
  let formFields = [
    {
      type: "input",
      name: "name",
      label: "Name",
      required: true,
    },
    {
      type: "reactselect",
      name: "state",
      label: "State",
      paginated: true,
      proxyUrl: STATE_FETCH_URL,
      required: true,
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];

  // let module = getAssignedModule(location.pathname);
  // let actionPermission = false;
  // if (!module || module === "") {
  //   actionPermission = true;
  // } else {
  //   let updatedModules = JSON.parse(
  //     localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
  //   );
  //   if (updatedModules[module]) {
  //     let modulePermissions = updatedModules[module].map((perm) => {
  //       if (typeof perm === "string") {
  //         return perm.toLowerCase();
  //       }
  //       return perm;
  //     });
  //     if (modulePermissions.includes("change status")) {
  //       actionPermission = true;
  //     }
  //   }
  // }
  // if (actionPermission) {
  //   formFields.push({
  //     type: "switch",
  //     name: "active",
  //     label: "Active?",
  //     required: true,
  //     nolabel: "No",
  //     yeslabel: "Yes",
  //   });
  // }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={DISTRICT_URL}
      listRoute={URLS.DISTRICT_CUSTOM_FIELDS}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="District"
    />
  );
};

export default DistrictForm;
